export const splitMessages = (message: string, line: number) => {
  return (message || "")
    .split(/[\n。.]/)
    .slice(0, line)
    .join("");
};
